import React, { Fragment } from 'react';
import { Header } from 'semantic-ui-react';
import OverallDelayDropdown from '../../dropdowns/OverallDelayDropdown';

const Delay = ({ onChange, value }) => (
  <Fragment>
    <Header as="h4">Delay</Header>
    <OverallDelayDropdown
      width={4}
      name="overallDelayAtDestination"
      label="Delay at destination"
      value={value}
      onChange={onChange}
    />
  </Fragment>
);

export default Delay;



// WEBPACK FOOTER //
// ./src/component/ClaimForm/Form/Delay.js